const setHasQueryClass = (field) => {
  field.closest('.js-search-form').classList.toggle('c-search-form--has-query', field.value !== '');
};

document.querySelectorAll('.js-search-input').forEach((field) => {
  setHasQueryClass(field);
  field.addEventListener('input', () => setHasQueryClass(field));
});

document.querySelectorAll('.js-search-clear').forEach((button) => {
  button.addEventListener('click', () => {
    const field = button.closest('.js-search-form').querySelector('.js-search-input');
    field.value = '';
    setHasQueryClass(field);
    field.focus();
  });
});
